const t=t=>!!t&&/^#([0-9a-fA-F]{3}){1,2}$/.test(t);export{t as isValidHexColor};
//# sourceMappingURL=isValidHexColor.js.map
